import React from "react";
import { Crown, Users, ShieldCheck } from "lucide-react";

const CONFIG = {
    primary: {
        icon: Crown,
        label: "Primary",
        classes: "bg-brand-blue-100 text-brand-blue-800 border-brand-blue-200",
    },
    secondary: {
        icon: Users,
        label: "Secondary",
        classes: "bg-amber-100 text-amber-800 border-amber-200",
    },
    backup: {
        icon: ShieldCheck,
        label: "Backup",
        classes: "bg-slate-100 text-slate-700 border-slate-200",
    },
};

const AssignmentRoleBadge = ({ role, size = "sm" }) => {
    const cfg = CONFIG[role] || CONFIG.backup;
    const Icon = cfg.icon;
    const pad = size === "xs" ? "px-1.5 py-0" : "px-2 py-0.5";
    const iconSize = size === "xs" ? "h-2.5 w-2.5" : "h-3 w-3";
    const textSize = size === "xs" ? "text-[9px]" : "text-[10px]";
    return (
        <span
            className={`inline-flex items-center gap-1 rounded-full border ${cfg.classes} ${pad} ${textSize} font-bold uppercase tracking-wider`}
        >
            <Icon className={iconSize} />
            {cfg.label}
        </span>
    );
};

export default AssignmentRoleBadge;
